import { render, staticRenderFns } from "./NonGeoPickls.vue?vue&type=template&id=2cbd52b5&scoped=true&"
import script from "./NonGeoPickls.vue?vue&type=script&lang=ts&"
export * from "./NonGeoPickls.vue?vue&type=script&lang=ts&"
import style0 from "./NonGeoPickls.vue?vue&type=style&index=0&id=2cbd52b5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbd52b5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cbd52b5')) {
      api.createRecord('2cbd52b5', component.options)
    } else {
      api.reload('2cbd52b5', component.options)
    }
    module.hot.accept("./NonGeoPickls.vue?vue&type=template&id=2cbd52b5&scoped=true&", function () {
      api.rerender('2cbd52b5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/NonGeoPickls.vue"
export default component.exports